import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, null, {
    default: _withCtx(() => [
      _createVNode(_component_ModalCard, {
        onCancel: _ctx.cancel,
        activeValidate: _ctx.nomZipValid,
        headerTitle: _ctx.$t('document.rapports.modal.nom.zip.header'),
        onConfirm: _ctx.download
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('document.rapports.modal.nom.zip.choix.label')), 1),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nomZip) = $event))
            }, null, 512), [
              [_vModelText, _ctx.nomZip]
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('document.rapports.modal.nom.zip.extension')), 1)
          ])
        ]),
        _: 1
      }, 8, ["onCancel", "activeValidate", "headerTitle", "onConfirm"])
    ]),
    _: 1
  }))
}